var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExpandIcon = function SvgExpandIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.461 19.418-5.46-5.459a8.5 8.5 0 1 0-1.042 1.043l5.459 5.46a.738.738 0 1 0 1.043-1.043ZM1.51 8.513a7.013 7.013 0 1 1 2.054 4.949A7 7 0 0 1 1.51 8.513Zm11.426 0a.736.736 0 0 1-.737.737H9.25v2.952a.737.737 0 1 1-1.474 0V9.25H4.827a.737.737 0 0 1 0-1.474h2.949V4.827a.737.737 0 0 1 1.474 0v2.949h2.951a.736.736 0 0 1 .737.737Z"
  })));
};
export default SvgExpandIcon;